// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aj0_","buttons":"styles_buttons__thaYp"};